<template>
  <el-dialog
    class="logindialog"
    :visible.sync="loginstatus"
    :show-close="false"
    :before-close="closelogin"
  >
    <div class="loginflex">
      <div class="body">
        <div
          class="change-login"
          v-show="logintype == 0"
          @click="changemodel(1)"
        >
         <!-- <div class="login-title">微信扫码登录</div>
          <div class="icon icon-wechat"></div> -->
        </div>
        <div
          class="change-login"
          v-show="logintype == 1"
          @click="changemodel(0)"
        >
          <div class="login-title">手机号登录</div>
          <div class="icon icon-phone"></div>
        </div>
        <div class="weChat-box" v-show="logintype == 1">
          <div class="login-tip-1">微信扫码一键登录</div>
          <div class="login-tip-2">未注册的微信号将自动创建{{website.web_title}}账号</div>
          <div class="qrcode">
            <el-image
              v-loading="loading"
              @load="loading = false"
              :src="wechat.qrcode"
              alt="qrcode"
              class="qrcode-image"
            ></el-image>
          </div>
        </div>
        <div class="phone-box" v-show="logintype == 0">
          <div class="login-tip-1">手机验证码登录</div>
          <div class="login-tip-2">未注册的手机号将自动创建{{website.web_title}}账号</div>
          <el-input
            class="phonenumber"
            placeholder="请输入手机号"
            v-model="form.mobile"
          >
            <p slot="prepend">+86<span class="phone-spacer"></span></p>
          </el-input>
          <div class="codebox">
            <el-input
              class="code"
              placeholder="输入验证码"
              v-model="form.code"
            ></el-input>
            <el-button
              style="width: 120px"
              type="primary"
              :disabled="disabled"
              plain
              class="codebutton"
              @click="smsSend()"
              >{{ text }}</el-button
            >
          </div>
          <el-button type="primary" class="submit" @click="userMobileLogin"
            >登录</el-button
          >
        </div>
      </div>
    </div>
    <div class="footer">
      欢迎使用{{website.web_title}}，您登录即同意<span @click="jumppage(1)">服务协议</span>、<span @click="jumppage(2)">隐私政策</span>
    </div>
  </el-dialog>
</template>

<script>
var _this;
import {
  wechatCode,
  userScanLogin,
  smsSend,
  userMobileLogin,
} from "@/api/login";
import { validatePhoneNumber } from "@/utils/commom";
export default {
  data() {
    return {
      loading: true,
      disabled: false,
      text: "获取验证码",
      second: 60,
      form: {
        mobile: "",
        code: "",
      },
	  website: this.$store.website,
      logintype: 0,
      loginstatus: true,
      wechat: {},
      this: "",
    };
  },
  mounted() {
    _this = this;
  },
  methods: {
    jumppage(index) {
      switch (index) {
        case 1:
          window.open(this.$store.website.serve_url)
          break;
        case 2:
          window.open(this.$store.website.privacy_url)
          break;
      }
    },
    changemodel(type) {
      _this.logintype = type;
      if (_this.logintype == 1) {
        _this.wechatCode();
      } else {
        clearInterval(_this.time);
      }
    },
    // 获取微信二维码
    wechatCode() {
      wechatCode().then((res) => {
        _this.wechat = res.data;
        _this.userScanLogin();
      });
    },
    //扫码登录
    userScanLogin() {
      _this.time = setInterval(() => {
        userScanLogin({ ticket: _this.wechat.ticket }).then((res) => {
          if (res.code == 0) {
            localStorage.setItem("gpt-token", res.data.token);
            localStorage.setItem("need_bind_mobile", res.data.need_bind_mobile);
			localStorage.setItem("loginStatus", 1);
            clearInterval(_this.time);
            location.reload();
          }
        });
      }, 1000);
    },
    smsSend() {
      if (!validatePhoneNumber(_this.form.mobile)) {
        _this.$message.error("手机号码格式错误");
        return false;
      }
      smsSend({ mobile: _this.form.mobile }).then((res) => {
        _this.disabled = true;
        let time = setInterval(() => {
          _this.text = _this.second + "s";
          _this.second--;
          if (_this.second == 0) {
            _this.second = 60;
            _this.disabled = false;
            clearInterval(time);
          }
        }, 1000);
      });
    },
    userMobileLogin() {
      if (!validatePhoneNumber(_this.form.mobile)) {
        _this.$message.error("手机号码格式错误");
        return false;
      }
      if (_this.form.code == "") {
        _this.$message.error("验证码不能为空");
        return false;
      }
	  _this.form.invite = sessionStorage.getItem('inviteCode');
      userMobileLogin(_this.form).then((res) => {
        if (res.code == 0) {
          localStorage.setItem("gpt-token", res.data.token);
		  localStorage.setItem("loginStatus", 1);
          setTimeout(function() {
			  location.reload();
		  }, 500);
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    closelogin() {
      _this.$emit("closelogin");
    },
  },
};
</script>

<style lang="less">
.logindialog {
  .el-dialog {
    height: 360px !important;
    width: 340px !important;
    border-radius: 12px !important;
    top: 32%;
    transform: translateY(-50%);
    .el-dialog__header {
      display: none;
    }
    .loginflex {
      display: flex;
      flex-direction: column;
      height: 100%;
      .body {
        flex: 1 0 10%;
        .change-login {
          font-size: 13px;
          line-height: 22px;
          color: #0076fe;
          position: absolute;
          right: 0;
          top: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          .icon {
            clip-path: polygon(0 0, 100% 0, 100% 100%);
            cursor: pointer;
            background: url(../../assets/ai-pc-icon-6fdc37eb.png) no-repeat;
            display: inline-block;
          }
          .icon-phone {
            width: 56px;
            height: 56px;
            background-position: -3px -145px;
          }
          .icon-wechat {
            width: 56px;
            height: 56px;
            background-position: -131px -145px;
          }
          .login-title {
            font-weight: 400;
            font-size: 13px;
            line-height: 22px;
            color: #0076fe;
            background: #f5f9ff;
            opacity: 0.75;
            border-radius: 3px;
            padding: 4px 12px;
            margin-right: 6px;
            cursor: pointer;
          }
        }
        .login-tip-1 {
          font-weight: 700;
          font-size: 20px;
          line-height: 26px;
          color: #1d2129;
          margin: 18px 0 4px;
        }
        .login-tip-2 {
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
          color: #999;
        }
        .weChat-box {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          height: 100%;
          .qrcode {
            box-sizing: border-box;
            padding: 5px;
            border: 1px solid #2d8af5;
            border-radius: 8px;
            margin-top: 24px;
            .qrcode-image {
              width: 140px;
              height: 140px;
            }
          }
        }
        .phone-box {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          height: 100%;
          .phonenumber {
            width: 289px;
            height: 40px;
            border-radius: 4px;
            margin-top: 24px;
            .el-input-group__prepend {
              background: #fff !important;
              padding: 0 4px 0 15px !important;
              border-right-color: transparent !important;
              p {
                display: flex;
                align-items: center;
              }
              .phone-spacer {
                display: inline-block;
                width: 0.5px;
                height: 16px;
                background-color: #e5e8ef;
                margin-left: 15px;
              }
            }
            .el-input__inner {
              border-left-color: transparent !important;
            }
          }
          .codebox {
            display: flex;
            justify-content: space-between;
            width: 290px;
            margin: 24px auto;
            .el-input {
              margin-right: 12px;
            }
          }
          .submit {
            width: 290px;
          }
        }
      }
    }
    .footer {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #999;
      width: 340px;
      height: 32px;
      background: #f5f9ff;
      position: absolute;
      bottom: 0;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
      box-sizing: border-box;
      padding: 8px;
      left: 0;
      text-align: center;
      span {
        color: #2d8af5;
        cursor: pointer;
      }
    }
  }
}
</style>